export default __webpack_public_path__ + "static/media/shield.6cf2bbd3.svg";